import { Checkbox as CheckboxComponent } from "@headlessui/react";
import clsx from "clsx";
import { useState } from "react";

function Checkbox({ cb, className }) {
  const [enabled, setEnabled] = useState(false);

  const onChange = (checked) => {
    setEnabled(checked);

    cb(checked);
  };

  return (
    <CheckboxComponent
      checked={enabled}
      onChange={onChange}
      className={clsx(
        "group block size-4 rounded border bg-white data-checked:bg-blue-500",
        className
      )}
    >
      {/* Checkmark icon */}
      <svg
        className="stroke-white opacity-0 group-data-checked:opacity-100"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M3 8L6 11L11 3.5"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </CheckboxComponent>
  );
}

export default Checkbox;
